import view from "../../views/training.js";
import { router } from "../router/index.routes.js";
import { _user, _handler, Toasted, Clip, ClipboardManager, CustomDialog, Countdown, soundManager } from "../classes/index.classes.js";
import KTAPI from "../api/index.api.js";
import { ioSocket, ioPings } from "../mm/index.mm.js";

import { errorMsg } from "./offscreen.controller.js";
import { KTLang } from "../lang/lang.js";
import KTCookie, { get } from "../components/cookie.js";

let states = [
    "DEAD",
    "WARM",
    "START",
    "FH",
    "HT",
    "SH",
    "OT",
    "END"    
];

let tempservers = [];

let practice = {
    render: () => {
        
        return view;
    },
    after_render: async () => {
        KTLang.update();
       
        let servers = await KTAPI.getServers('practice');
        //console.log(servers);
        
        if(servers.message == 'done' && servers.res.length > 0) { 

            tempservers = servers.res;
            renderLobbyList(servers.res);            
            reorderServersList();
            
        }
        else
        {
            $("#lobby-list-loader").addClass("d-none");
            $("#lobby-list-empty").removeClass("d-none");
        }
        
        if(serverInfoModal === null) serverInfoModal = new ModalManager(modalOptions);
        //console.log(serverInfoModal);
    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_content'
};

/*class ModalManager {
    constructor(options) {
        this.options = options;
        this.$modal = null;
        this.createModal();
        this.ClipModal = new ClipboardManager('.clip-modal', {container: this.$modal});
    }

    createModal() {
        // Crear elemento modal
        const $modalElement = `
            <div class="modal modal-server-dialog fade">
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                    <div class="modal-content bg-gray-100">
                        <div class="modal-header border-0 pt-4 pb-2">
                            <div class="d-flex flex-grow-1 justify-content-center align-items-center">
                                <h3 class="modal-title teko-header">${this.options.title}</h3>
                            </div>
                            <div class="btn btn-sm btn-icon btn-light btn-active-light-primary" data-bs-dismiss="modal">
                                <i class="bi bi-x-lg fs-6"></i>
                            </div>
                    
                        </div>
                        <div class="modal-body border-0 pt-0">
                            ${this.options.content}
                        </div>
                        <div class="modal-footer border-0 justify-content-between">
                            <button class="btn btn-sm btn-light bg-gray-200 clip" data-clipboard-target="#foo" i18n-label="example.copied_server">
                                <i class="fas fa-clone"></i>
                                <span class="modal-server">IP ${this.options.server}</span>
                            </button>
                            <input id="foo" class="d-none" value="connect ${this.options.server}">
                            <a href="steam://connect/${this.options.server}" class="btn btn-sm btn-light bg-gray-200 btn-active-primary btn-active-color-gray-200 lobby-btn-connect external-handler">
                                <i class="fas fa-play"></i>
                                <span class="">Join</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        `;

        // Agregar modal al DOM
        //$('body').append($modalElement);
        $("#kt_offscreen").append($modalElement);

        // Inicializar modal usando jQuery
        //this.$modal = $modalElement.modal("hide");
        this.$modal = $("#kt_offscreen").find(".modal-server-dialog").modal("hide");

        return this.$modal;
    }

    updateModal(options) {

       

        // Actualizar opciones del modal
        this.options = options;

        let copyBtn = `<button class="btn btn-sm btn-light bg-gray-200 clip" data-clipboard-text="connect ${this.options.server}" i18n-label="example.copied_server">
            <i class="fas fa-clone"></i>
            <span class="modal-server">IP ${this.options.server}</span>
        </button>`;

        // Actualizar contenido del modal
        this.$modal.find('.modal-title').text(this.options.title);
        this.$modal.find('.modal-body').html(this.options.content);
        //this.$modal.find('.modal-footer .btn-primary').text(this.options.primaryButtonText);
        if(this.options.bg !== undefined || this.options.bg !== null || this.options.bg !== '')
        {
            this.$modal.find('.modal-content').attr("style", this.options.bg);
        }
        //this.$modal.find('.clip').remove();
        //this.$modal.find('.modal-footer').prepend(copyBtn);
        this.$modal.find('#foo').val(`connect ${this.options.server}`);
        this.$modal.find('.modal-server').text(`IP ${this.options.server}`);
        this.$modal.find('.lobby-btn-connect').attr("href", `steam://connect/${this.options.server}`);
    }
}*/

class ModalManager {
    constructor(options) {
        this.options = options;
        this.$modal = null;
        this.createModal();
        while (this.$modal === null) {            
        }
        this.ClipModal = new ClipboardManager('.clip-modal', {container: this.$modal[0]});
    }

    createModal() {
        const $modalElement = `
            <div class="modal modal-server-dialog fade">
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                    <div class="modal-content bg-gray-100">
                        <div class="modal-header border-0 pt-4 pb-2">
                            <div class="d-flex flex-grow-1 justify-content-center align-items-center">
                                <h3 class="modal-title teko-header">${this.options.title}</h3>
                            </div>
                            <div class="btn btn-sm btn-icon btn-light btn-active-light-primary" data-bs-dismiss="modal">
                                <i class="bi bi-x-lg fs-6"></i>
                            </div>
                    
                        </div>
                        <div class="modal-body border-0 pt-0">
                            ${this.options.content}
                        </div>
                        <div class="modal-footer border-0 justify-content-between">
                            <button class="btn btn-sm btn-light bg-gray-200 clip-modal" data-clipboard-text="connect ${this.options.server}" i18n-label="example.copied_server">
                                <i class="fas fa-clone"></i>
                                <span class="modal-server">IP ${this.options.server}</span>
                            </button>
                            <input id="foo" class="d-none" value="connect ${this.options.server}">
                            <a href="steam://connect/${this.options.server}" class="btn btn-sm btn-light bg-gray-200 btn-active-primary btn-active-color-gray-200 lobby-btn-connect external-handler">
                                <i class="fas fa-play"></i>
                                <span class="">Join</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        `;

        $("#kt_offscreen").append($modalElement);
        this.$modal = $("#kt_offscreen").find(".modal-server-dialog").modal("hide");

        return this.$modal;
    }

    updateModal(options) {
        this.options = options;

        this.$modal.find('.modal-title').text(this.options.title);
        this.$modal.find('.modal-body').html(this.options.content);

        if(this.options.bg !== undefined && this.options.bg !== null && this.options.bg !== '') {
            this.$modal.find('.modal-content').attr("style", this.options.bg);
        }

        this.$modal.find('#foo').val(`connect ${this.options.server}`);
        this.$modal.find('.clip-modal').attr("data-clipboard-text", `connect ${this.options.server}`);
        this.$modal.find('.modal-server').text(`IP ${this.options.server}`);
        this.$modal.find('.lobby-btn-connect').attr("href", `steam://connect/${this.options.server}`);
    }
}

const modalOptions = {
    title: 'Modal Title',
    content: '<p>This is the modal content</p>',
    server: 'connect '
};
let serverInfoModal = null;


$(document).ready(function(){

    _handler.on('ping', async (data) => {        
        reorderServersList();
    });

    $(document).on("click", ".selector", function(e){
        e.preventDefault();        
        $(".selector").removeClass("active");
        $(this).addClass("active");
        let type = $(this).attr("selector");
        if(type == "all")
        {
            $(".servers-section").removeClass("d-none");
        }
        else
        {
            $(".servers-section").addClass("d-none");
            $(".servers-section.section-"+type).removeClass("d-none");
        }
    });


    $(document).on("click", ".sv-lobby.sv-training-lobby[data-sv-id]", function(e){
        e.preventDefault();
        let id = $(this).attr("data-sv-id");
        let server = tempservers.find(sv => sv._id == id);
        //console.log("rendering this", server);
        renderServerInfoModal(server);
    });

    $(document).on("click", ".mm-quick-match", async function(e){
        e.preventDefault();
        $(this).addClass("disabled");

        let type = $(this).attr("data-type");
        let mode = $(this).attr("data-mode");
        
        let pings = {};
        Object.keys(ioPings).forEach(key => {
            pings[key] = ioPings[key].ping;
        });

        let data = {
            type: type,
            mode: mode,
            pings: pings
        };

        let res = _user.authed ? await KTAPI.quickMatchLogged(data) : await KTAPI.quickMatchNotLogged(data);

        if(res.message == 'error')
        {   
            console.log("[MATCHMAKING] Error", res.error);         
            if(res.error === 'no_servers_available') await errorDlg(res.error);
            
        }else
        {
            console.log("[MATCHMAKING] Success", res);
            await foundMatchDlg(res.server);            
        }

        $(this).removeClass("disabled");

    });

   
});

function reorderServersList()
{        
    sortServerDivs(".servers-list.type-csdm", ["data-ping","data-players"], [1, -1]);
}

/**
 * 
 *  SOCKET.IO PROCESSESS
 * 
 */

const trainingSocket = (socket) => {
        
    socket.on("sv_update_training", async (data) => {
        //console.log(data);
        updateLobby(data.sv);
        reorderServersList();

    });   
    
    
    socket.on('lobby-error', async (data) => {
        errorMsg({title:"Hey!",content:data.msg});return;
    });

};

export { trainingSocket };



/**
 * 
 *  RENDER FUNCTIONS
 * 
 */

const renderServerInfoModal = (data) => {
    //console.log(data);    
    let cont = renderServerInfoModalContent(data);    

    let bg = `background-image: linear-gradient(to bottom, rgba(27, 27, 27, 0.4) 0px, rgb(27, 27, 27) 26rem, rgb(27, 27, 27) 74rem, rgba(31, 31, 31, 0.5) 100%),url(assets/media/maps/1080px/${data.map}.jpg);
    background-size: 100% auto;
    background-repeat: no-repeat;`;

    serverInfoModal.updateModal({title: data.tag, content: cont, server: data.server, bg: bg});
    serverInfoModal.$modal.modal('show');

    function renderServerInfoModalContent(data) {

        if(data.players === undefined) data.players = {};

        data.players = Object.keys(data.players).reduce((newPlayers, key) => {
            let player = data.players[key];
            player.kdr = (player.kills/(player.deaths == 0 ? 1 : player.deaths)).toFixed(2);
            player.hsp = ((player.hs/(player.kills == 0 ? 1 : player.kills))*100).toFixed(0);
            player.connected_time = moment.utc(player.connection_time*1000).format('HH:mm:ss');
            newPlayers[key] = player;
            return newPlayers;
        }, {});



        let playersRows = '';
        Object.keys(data.players).forEach(key => {
            if(data.players[key].connected == false) return;
            playersRows += renderPlayerRow(data.players[key]);
        });
        
        let html = /* html */`
            <div class="d-table w-100">
                <div class="d-table-row fw-bold text-gray-800 teko-semibold fs-4 bg-gray-100">
                    <div class="d-table-cell py-2 px-3 ps-4 rounded-start text-center">
                        <span class="text-dark">${data.act_players}/${data.max_players}</span>
                    </div>
                    <div class="d-table-cell py-2 px-3 text-center">
                        <span class="text-dark">Player</span>
                    </div>
                    <div class="d-table-cell py-2 px-3">
                        <span class="text-dark">Points</span>
                    </div>
                    <div class="d-table-cell py-2 px-3">
                        <span class="text-dark">K</span>
                    </div>
                    <div class="d-table-cell py-2 px-3">
                        <span class="text-dark">KDR</span>
                    </div>
                    <div class="d-table-cell py-2 px-3">
                        <span class="text-dark">HS%</span>
                    </div>
                    <div class="d-table-cell py-2 px-3">
                        <span class="text-dark">Ping</span>
                    </div>
                    <div class="d-table-cell py-2 px-3 pe-4 rounded-end text-center">
                        <span class="text-dark">In Game</span>
                    </div>                    
                </div>
                ${playersRows}
            </div>
        `;

        return html;

        function renderPlayerRow(player) {
            if(data.users[player.steamid] === undefined || data.users[player.steamid] == null || data.stats[player.steamid] === undefined || data.stats[player.steamid] == null) return '';
            let html = /* html */`
                <div class="d-table-row fs-8 text-gray-800">
                    <div class="d-table-cell py-2 px-3 ps-4 rounded-start align-middle lh-0 text-center">
                        <div class="symbol symbol-35px rounded overflow-hidden ${window.isMobile ? '' : 'popover-profile'}" data-steamid="${player.steamid}">
                            <span class="symbol-label bg-light">
                                <img src="${data.users[player.steamid].avatar}" class="h-100 align-self-end" alt="">
                            </span>
                        </div>
                    </div>
                    <div class="d-table-cell py-2 px-3 align-middle">
                        <div class="d-flex align-items-center"><img class="me-2" src="assets/media/flags/${data.users[player.steamid].countrycode.toLowerCase()}.gif"><a href="user/${data.users[player.steamid].communityid}" data-navigo class="text-dark text-truncate fs-8">${sanitizeHTML(data.users[player.steamid].nickname)}</a></div>
                    </div>
                    <div class="d-table-cell py-2 px-3 align-middle">
                        <span class="">${player.points}</span>
                    </div>
                    <div class="d-table-cell py-2 px-3 align-middle">
                        <span class="">${player.kills}</span>
                    </div>
                    <div class="d-table-cell py-2 px-3 align-middle">
                        <span class="">${player.kdr}</span>
                    </div>
                    <div class="d-table-cell py-2 px-3 align-middle">
                        <span class="">${player.hsp}%</span>
                    </div>
                    <div class="d-table-cell py-2 px-3 align-middle">
                        <span class="">${player.ping} ms</span>
                    </div>
                    <div class="d-table-cell py-2 px-3 pe-4 rounded-end text-center align-middle">
                        <span class="">${player.connected_time}</span>
                    </div>                    
                </div>
            `;

            return html;
        }
    }
};


const renderLobbyList = (data) => {
    let number = 0;    
    let html = {};
    data.map(sv => {        
        number++;
        sv.number = number;
                
        if(html[sv.type] == undefined) html[sv.type] = [];
        html[sv.type].push(renderLobby(sv));
        
    });

    Object.keys(html).forEach(function(key, index) {
        //console.log(key);
        $(`.selector.selector-${key}`).removeClass("d-none");
        $(`.servers-section.section-${key}`).removeClass("d-none");
        $(`.servers-section.section-${key}`).find(".servers-quantity").text(html[key].length);

        $(`.servers-list.type-${key}`).after(html[key]);
    });
    
    
    router.updatePageLinks();   
}

const renderLobby = (data) => {    
    let playerPercent = parseInt((data.act_players/data.max_players)*100);
    let html = /* html */`
        <div id="sv-lobby-${data._id}" class="sv-lobby sv-training-lobby cursor-pointer d-table-row fs-8 text-gray-800 bgi-position-y-center lobby-map-bg" data-players="${data.act_players}" data-location="${data.location}" data-city="${data.city}" data-ping="${ioPings[data.location] === undefined || ioPings[data.location].ping == 0 ? 9999: ioPings[data.location].ping}" data-sv-id="${data._id}" style="background-image: linear-gradient(to right, rgba(27, 27, 27, 0.4) 0px, rgb(27, 27, 27) 26rem, rgb(27, 27, 27) 74rem, rgba(31, 31, 31, 0.5) 100%),url('assets/media/maps/300px/${data.map}.jpg');">
            <div class="d-table-cell py-2 px-3 ps-4 rounded-start">
                <span class="my-1">${data.number}</span>
            </div>
            <div class="d-table-cell py-2 px-3">
                <div class="d-flex align-items-center flex-column">
                    <span class="fw-bold my-1 fs-7 text-gray-900 fw-bolder"><span class="lobby-act-players">${data.act_players}</span>/<span class="lobby-max-players">${data.max_players}</span></span>
                    <div class="progress h-4px" style="width:50%">
                        <div class="lobby-bar-players progress-bar ${getPlayersColor(data.act_players,data.max_players)} wp-${playerPercent}" role="progressbar"></div>
                    </div>
                </div>
            </div>
            <div class="d-table-cell py-2 px-3">
                <div class="d-flex align-items-center">
                    <div class="me-2"><img class="" src="assets/media/flags/${data.flag}.gif"></div><span class="fw-bold my-1">${data.region}</span>
                </div>
            </div>
            <div class="d-table-cell py-2 px-3">
                <i class="bi bi-bar-chart-fill ${getPingColor(ioPings[data.location] === undefined ? 9999 : ioPings[data.location])}" data-iconping="${data.location}"></i>
                <span class="fw-bold fs-7 my-1" data-showping="${data.location}">${ioPings[data.location] === undefined || ioPings[data.location].ping == 0 ? `<div    class="spinner-border text-primary text-center" role="status" style="width: 11px; height: 11px;"><span class="visually-hidden">Loading...</span></div>` : ioPings[data.location].ping}</span>
                <span>ms</span>
            </div>
            <div class="d-table-cell py-2 px-3">
                <span class="fw-bold my-1 lobby-map-name">${data.map}</span>
            </div>
            <div class="d-table-cell py-2 px-3 pe-4 rounded-end">
            
                <div class="btn-toolbar my-1 justify-content-center" role="toolbar">
                    <div class="btn-group" role="group">
                        <button class="btn btn-icon btn-light bg-gray-200 clip" data-clipboard-text="connect ${data.server}" i18n-label="example.copied_server">
                            <i class="fas fa-clone"></i>
                        </button>
                        <a href="steam://connect/${data.server}" class="btn btn-icon btn-light bg-gray-200 btn-active-primary btn-active-color-gray-200 lobby-btn-connect external-handler">
                            <i class="fas fa-play"></i>
                        </a>
                    </div>
                </div>
                
            </div>
            
        </div>
                `;
   
    
    html = $(html);
    
    html.localize();
    router.updatePageLinks();
    return html;
}

function updateLobby(data)
{
    //console.log(data._id);
    manageTempServers(data);

    Object.keys(data).forEach(function(key, index) {
        if(key == 'map')
        {            
            //$("#sv-lobby-"+data._id).find(".lobby-map-bg").css("background-image", `url('assets/media/maps/300px/${data[key]}.jpg')`);
            let css = $("#sv-lobby-"+data._id).attr("style");

            //reemplaza en la cadena de css url('assets/media/maps/300px/ + cualquiercosa + .jpg') por url('assets/media/maps/300px/ + data[key] + .jpg')
            css = css.replace(/url\('assets\/media\/maps\/300px\/.*\.jpg'\)/, `url('assets/media/maps/300px/${data[key]}.jpg')`);
            console.log(css);
            $("#sv-lobby-"+data._id).attr("style", css);
            
            $("#sv-lobby-"+data._id).find(".lobby-map-name").text(data[key]);        
        }
        if(key == 'act_players')
        {   
            $("#sv-lobby-"+data._id).attr("data-players", data[key]);         
            $("#sv-lobby-"+data._id).find(".lobby-act-players").text(data[key]);
            if(data[key] >= data.max_players)
            {
                $("#sv-lobby-"+data._id).find(".lobby-btn-connect").addClass("disabled");
            }
            else
            {
                $("#sv-lobby-"+data._id).find(".lobby-btn-connect").removeClass("disabled");
            }

            let percent = parseInt((data[key]/parseInt($("#sv-lobby-"+data._id).find(".lobby-max-players").text()))*100);
            //de $("#sv-lobby-"+data._id).find(".lobby-bar-players") remueve todas las clases que empiecen por wp- y bg-
            $("#sv-lobby-"+data._id).find(".lobby-bar-players").removeClass(function (index, className) {
                return (className.match(/(^|\s)wp-\S+/g) || []).join(' ');
            });
            $("#sv-lobby-"+data._id).find(".lobby-bar-players").addClass(`wp-${percent}`);
            $("#sv-lobby-"+data._id).find(".lobby-bar-players").addClass(getPlayersColor(data[key],parseInt($("#sv-lobby-"+data._id).find(".lobby-max-players").text())));
        }
        
    });
    $("#sv-lobby-"+data._id).localize();
    router.updatePageLinks();    
}

function manageTempServers(data){
    //data es el objeto que viene del socket con la info del server que se actualizó identificado por data._id y este servidor se encuentra en tempservers, necesito actualizar la info del servidor en el array tempservers con la info de data, la info de data puede ser parcial o completa, por lo que debo recorrer todas las keys de data y actualizar el valor de tempservers con la key correspondiente
    tempservers = tempservers.map(server => {
        if (server._id === data._id) {
            /*if(data.players !== undefined && !Object.keys(data.players).length) delete data.players;
            if(data.users !== undefined && !Object.keys(data.users).length) delete data.users;
            if(data.stats !== undefined && !Object.keys(data.stats).length) delete data.stats;
            Object.keys(data).forEach(key => {
                if(data[key] == null)
                {
                    delete server[key];
                }
                else
                {
                    if(key == 'players' || key == 'users' || key == 'stats')
                    {
                        Object.keys(data[key]).forEach(k => {
                            if(data[key][k] == null)
                            {
                                delete server[key][k];
                            }
                            else
                            {
                                if(server[key] == undefined) server[key] = {};
                                server[key][k] = data[key][k];
                                
                            }
                        });
                    }
                    else
                    {
                        server[key] = data[key];
                    }                    
                }                
            });*/

            if(data.hasOwnProperty('connected'))
            {
                if(data.connected == false)
                {
                    delete server.players[data.steamid];
                    delete server.users[data.steamid];
                    delete server.stats[data.steamid];
                }
                else
                {
                    if(server.players == undefined) server.players = {};
                    if(server.users == undefined) server.users = {};
                    if(server.stats == undefined) server.stats = {};
                    server.players[data.steamid] = data.player;
                    server.users[data.steamid] = data.user;
                    server.stats[data.steamid] = data.stats;
                }
            }
            else
            {
                if(data.hasOwnProperty('act_players') && data.act_players == 0)
                {
                    server.players = {};
                    server.users = {};
                    server.stats = {};
                }
                Object.keys(data).forEach(key => {
                    server[key] = data[key];
                });            
            }
        }
        return server;
    }); 
}

const getPingColor = (ping) => {
    if(ping <= 50) return "text-success";
    if(ping <= 100) return "text-zyellow";
    if(ping <= 150) return "text-zorange";
    if(ping <= 200) return "text-danger";
    if(ping <= 999) return "text-gray-600";
    return "text-muted";
};

const getPlayersColor = (players,totalPlayers) => {
    let percent = (players/totalPlayers)*100;
    if(percent < 1) return "";
    if(percent <= 33) return "bg-success";
    if(percent <= 66) return "bg-zyellow";
    if(percent < 100) return "bg-zorange";
    if(percent >= 100) return "bg-danger";
    return "";
};
function sortServerDivs(parentSelector, attributes, order) {
    var $divs = $(`${parentSelector} ~ div`).detach();

    $divs.sort(function(a, b) {
        for (var i = 0; i < attributes.length; i++) {
            var attr = attributes[i];
            var aValue = $(a).attr(attr);
            var bValue = $(b).attr(attr);

            // Comprobar si los valores son números
            if (!isNaN(aValue) && !isNaN(bValue)) {
                aValue = Number(aValue);
                bValue = Number(bValue);
            }

            // Comparar los valores
            if (aValue < bValue) {
                return -1 * order[i];
            } else if (aValue > bValue) {
                return 1 * order[i];
            }
        }

        // Si llegamos a este punto, todos los atributos son iguales
        return 0;
    });

    // Reinsertar los divs en el div padre
    //console.log($divs);
    $(`${parentSelector}`).parent().append($divs);
}

function sanitizeHTML(html) {
    const $temp = $("<div>");
    $temp.html(html);
    const sanitizedHTML = $temp.text();
    return sanitizedHTML;
}

async function errorDlg(error) {
  
    let title = `<span><i class="fas fa-exclamation-circle text-danger fs-4 me-2"></i><span class="" data-i18n="error.solo.error"></span></span>`;
    let content = `<p class="mb-1 text-gray-800" data-i18n="error.training.${error}"></p>`;
    let accept = `<span class="" data-i18n="error.solo.close"></span>`;    

    title = $(title).localize();
    content = $(content).localize();
    accept = $(accept).localize().text();    

    // Envuelve la lógica del diálogo en una Promesa
    const dialogResult = await new Promise((resolve) => {
        const dialog1 = new CustomDialog({
            title: title[0].outerHTML,
            content: content[0].outerHTML,
            buttons: [{
                    text: accept,
                    class: 'btn btn-sm btn-primary btn-text-gray-100 btn-active-light-primary btn-active-color-primary fw-bolder',
                    callback: function () {
                        resolve('accept');
                    },
                    dismiss: true
                },                
            ],
            onHide: function () {
                
            },
            disableCloseButton: false,
            noBackdrop: false,
            verticallyCentered: true,
            scrollable: true
        });

        dialog1.show();
    });

    // Usa el resultado de la Promesa para continuar con la lógica correspondiente
    if (dialogResult === 'accept') {
        //console.log('Aceptado');
        // Lógica para manejar la aceptación
        return 1
    } else {
        //console.log('Cancelado');
        // Lógica para manejar la cancelación
        return 0;
    }
}

async function foundMatchDlg(data) {
    
    let title = `<span class="text-gray-100 teko-header fs-2" data-i18n="solo.confirm_match_dlg_title">YOUR MATCH IS READY</span>`;
    let content = `<div class="d-flex flex-column align-items-center justify-content-center">
                        
                        <div class="solo-queue-list d-flex flex-column align-items-center justify-content-center mb-6">
                            <span class="text-gray-800 fs-6" data-i18n="solo.confirm_match_dlg_text">Confirm your match:</span>
                            <span class="fs-6 fw-bolder text-uppercase mb-3"><span class="text-gray-900">${data.type}</span> - <span class="text-gray-700">${data.mode}</span></span>
                            <span class="fs-7 fw-bold"><img src="assets/media/flags/${data.flag}.gif"> ${data.region}</span>
                        </div>
                        <span class="count-confirm text-white fs-2 teko-header"></span>
                        
                    </div>                     
                    `;
    
    let server = `<i class="fas fa-clone"></i><span class="">IP ${data.server}</span>`;    
    let join = `<i class="fas fa-play"></i><span class="">Join</span>`;
    
    title = $(title).localize();
    content = $(content).localize();    
    router.updatePageLinks();
    let ClipModal = null;

    // Envuelve la lógica del diálogo en una Promesa
    const dialogResult = await new Promise((resolve) => {
        const dialog1 = new CustomDialog({
            title: title[0].outerHTML,
            content: content[0].outerHTML,
            buttons: [
                {
                    text: server,
                    class: `btn btn-sm btn-light bg-gray-200 clip-cmodal" data-clipboard-text="connect ${data.server}`,
                    attributes: 'i18n-label="example.copied_server"',
                    callback: function () {
                        
                    },
                    dismiss: false
                },
                {
                    text: join,
                    class: 'btn btn-sm btn-light-primary btn-active-primary btn-active-color-gray-200 external-handler',
                    attributes: `href="steam://connect/${data.server}"`,
                    callback: function () {                        
                    },
                    dismiss: true
                }
            ],
            onHide: function () {
                ClipModal.destroy();
            },
            onShow: function() {
                soundManager.playSound('found');
                let count = new Countdown({
                    displayElement: '.count-confirm',
                    seconds: parseInt(data.confirmationTimeout),
                });
                count.start();
                router.updatePageLinks();
            },
            disableCloseButton: true,
            noBackdrop: false,
            verticallyCentered: true,
            scrollable: true,
            autoHide: true,
            autoHideDelay: data.confirmationTimeout*1000,
            headerClasses: "bg-primary",
            footerClass: "justify-content-center",
        });
        //confimDialog = dialog1;
        ClipModal = new ClipboardManager('.clip-cmodal', {container: document.getElementById(dialog1.getDialogId())});

        dialog1.show();

        resolve('accept');
    });

    // Usa el resultado de la Promesa para continuar con la lógica correspondiente
    if (dialogResult === 'accept') {
        //console.log('Aceptado');
        // Lógica para manejar la aceptación
        return 1
    } else {
        //console.log('Cancelado');
        // Lógica para manejar la cancelación
        return 0;
    }
}


export default practice;